import { GET_STORE_QUERY } from './schema';

export async function getStore(client, options = {}) {
  const response = await client.query({
    query: GET_STORE_QUERY,
    ...options,
  });

  return {
    data: response.data?.getStore,
    error: response.error,
  };
}
